import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGetAnnouncementsArgs,
  IGetAnnouncementsPayload,
  IOtherManagementState
} from '../types';
import otherManagementServices from '../otherManagementServices';

export const getAnnouncements = createAsyncThunk<
  IGetAnnouncementsPayload,
  IGetAnnouncementsArgs | undefined,
  ThunkAPIConfig
>('getAnnouncements', async (args, { rejectWithValue }) => {
  try {
    const { data } = await otherManagementServices.getAnnouncements({
      page: args?.page || 1,
      limit: args?.limit || 5
    });

    return {
      data: data.data.result,
      pagination: data.data.metaData
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getAnnouncementsBuilder = (
  builder: ActionReducerMapBuilder<IOtherManagementState>
) => {
  const { pending, fulfilled, rejected } = getAnnouncements;
  builder
    .addCase(pending, draftState => {
      draftState.announcement.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      draftState.announcement.loading = false;
      draftState.announcement.data = action.payload.data;
      draftState.announcement.pagination = action.payload.pagination;
    })
    .addCase(rejected, draftState => {
      draftState.announcement.loading = false;
    });
};
